export default __webpack_public_path__ + "static/media/promo-banner-lenovo.78d81c23.jpg";